<template>
  <div>
    <!-- <h2 class="content-block">Pegawai Page</h2>
    <div></div> -->
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div class="container">
          <div class="left-content">
            <DxTreeView
              :data-source="continents"
              :select-by-click="true"
              selection-mode="single"
              @item-selection-changed="changeSelection"
            />
          </div>
          <div class="right-content">
            <div class="title-container">
              <!-- <img :src="countryData.flag" class="flag" /> -->
              <div class="flag">
                <!-- <img v-bind:src="imageSrc" /> -->
              </div>
              <div>
                <div class="country-name" v-if="pegawaiResponse">
                  {{ pegawaiResponse.nama }}
                </div>
                <div v-if="jobHistoryReponse">
                  {{ jobHistoryReponse[0].jabatan.nama }}
                  <div
                    v-if="jobHistoryReponse[0].subBagian"
                    style="display: inline"
                  >
                    - {{ jobHistoryReponse[0].subBagian.nama }}
                  </div>
                  <div
                    v-if="jobHistoryReponse[0].bagian"
                    style="display: inline"
                  >
                    - {{ jobHistoryReponse[0].bagian.nama }}
                  </div>
                  - {{ jobHistoryReponse[0].cabang.nama }}
                </div>
              </div>
            </div>

            <!-- <div class="sub-title" style="display: block">
             
            </div> -->
            <br />
            <DxTabPanel
              id="tabpanel"
              v-model:selected-index="tabPanelIndex"
              :data-source="citiesData"
              :animation-enabled="true"
              item-title-template="title"
              item-template="currentTemplate"
              @titleClick="tabTitleClick"
            >
              <template #title="{ data: item }">
                <span class="tab-panel-title">{{ item.text }}</span>
              </template>

              <template #tEdFormal>
                <DxDataGrid
                  id="dataGridEdFormal"
                  :data-source="pendidikanHistorySource"
                  :focused-row-index="0"
                  :show-borders="true"
                  :show-column-lines="false"
                  :focused-row-enabled="true"
                  :column-auto-width="true"
                  :column-hiding-enabled="false"
                  :allow-column-reordering="true"
                  key-expr="id"
                >
                  <dx-paging :page-size="10" />
                  <dx-pager :show-page-size-selector="true" :show-info="true" />
                  <dx-filter-row :visible="true" />

                  <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"
                  />
                  <DxSelection mode="multiple" />
                  <DxColumnFixing :enabled="true" />
                  <DxToolbar>
                    <DxItem name="groupPanel" />
                    <DxItem location="after" template="button-template" />
                    <DxItem name="addRowButton" show-text="always" />
                    <DxItem name="exportButton" />
                    <DxItem name="columnChooserButton" />
                    <DxItem name="searchPanel" />
                  </DxToolbar>
                  <template #button-template>
                    <DxButton
                      text="Import data"
                      :width="136"
                      @click="importClick"
                    />
                  </template>
                  <dx-column
                    data-field="pendidikan_jenjang_id"
                    caption="Jenjang"
                  >
                    <DxLookupDataGrid
                      :data-source="pendidikanJenjangSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                  <dx-column
                    data-field="institusi"
                    caption="Nama institusi"
                  ></dx-column>
                  <dx-column
                    data-field="fakultas"
                    caption="Fakultas"
                  ></dx-column>
                  <dx-column data-field="jurusan" caption="Jurusan"></dx-column>
                  <dx-column data-field="ipk" caption="IPK"></dx-column>
                  <dx-column
                    data-field="tahun_mulai"
                    caption="Tahun Mulai"
                  ></dx-column>
                  <dx-column
                    data-field="tahun_lulus"
                    caption="Tahun Lulus"
                  ></dx-column>
                  <dx-column
                    data-field="ijazah_no"
                    caption="Nomor Ijazah"
                  ></dx-column>
                  <dx-column
                    data-field="ijazah_tgl"
                    caption="Tgl Ijazah"
                    data-type="date"
                    :format="'dd/MM/yyyy'"
                  ></dx-column>
                  <dx-column
                    data-field="ijazah_file"
                    caption="File"
                  ></dx-column>
                </DxDataGrid>
              </template>

              <template #tEdInformal>
                <DxDataGrid id="dataGridEdInformal" key-expr="ID">
                  <dx-column data-field="ID" caption="No" />
                  <dx-column data-field="nama" caption="Name" />
                  <dx-column data-field="Address" caption="Held by" />
                  <DxColumn
                    data-field="Position"
                    caption="Start date"
                  ></DxColumn>
                  <DxColumn data-field="Position" caption="End year"></DxColumn>
                  <DxColumn data-field="Position" caption="Duration"></DxColumn>
                  <DxColumn data-field="Position" caption="Fee"></DxColumn>
                  <DxColumn
                    data-field="Position"
                    caption="Certificate"
                  ></DxColumn>
                </DxDataGrid>
              </template>

              <template #tEdWorking>
                <DxDataGrid id="dataGridEdWordking" key-expr="ID">
                  <dx-column data-field="ID" caption="No" />
                  <dx-column data-field="nama" caption="Company" />
                  <dx-column data-field="Address" caption="Position" />
                  <DxColumn data-field="Position" caption="From"></DxColumn>
                  <DxColumn data-field="Position" caption="To"></DxColumn>
                  <DxColumn
                    data-field="Position"
                    caption="Length of service"
                  ></DxColumn>
                </DxDataGrid>
              </template>

              <template #tEmployment>
                <DxDataGrid
                  id="dataGridX"
                  :data-source="jobHistoryReponse"
                  :focused-row-index="0"
                  :show-borders="true"
                  :show-column-lines="false"
                  :focused-row-enabled="true"
                  :column-auto-width="true"
                  :column-hiding-enabled="false"
                  :allow-column-reordering="true"
                  key-expr="id"
                >
                  <dx-paging :page-size="10" />
                  <dx-pager :show-page-size-selector="true" :show-info="true" />
                  <dx-filter-row :visible="true" />

                  <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"
                  />
                  <DxSelection mode="multiple" />
                  <DxColumnFixing :enabled="true" />
                  <DxToolbar>
                    <DxItem name="groupPanel" />
                    <DxItem location="after" template="button-template" />
                    <DxItem name="addRowButton" show-text="always" />
                    <DxItem name="exportButton" />
                    <DxItem name="columnChooserButton" />
                    <DxItem name="searchPanel" />
                  </DxToolbar>
                  <template #button-template>
                    <DxButton
                      text="Import data"
                      :width="136"
                      @click="importClick"
                    />
                  </template>

                  <dx-column data-field="jabatan_id" caption="Jabatan">
                    <DxLookupDataGrid
                      :data-source="jabatanSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                  <dx-column data-field="golongan_id" caption="Golongan">
                    <DxLookupDataGrid
                      :data-source="golonganSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                  <dx-column data-field="sub_bagian_id" caption="Sub Bagian">
                    <DxLookupDataGrid
                      :data-source="subBagianSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                  <dx-column data-field="bagian_id" caption="Bagian">
                    <DxLookupDataGrid
                      :data-source="bagianSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                  <dx-column data-field="cabang_id" caption="Cabang">
                    <DxLookupDataGrid
                      :data-source="cabangSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                  <dx-column
                    data-field="tgl_mulai"
                    caption="Tgl Mulai"
                    data-type="date"
                    :format="'dd/MM/yyyy'"
                    :allow-sorting="true"
                  />
                  <dx-column
                    data-field="tgl_akhir"
                    caption="Tgl Akhir"
                    data-type="date"
                    :format="'dd/MM/yyyy'"
                    :allow-sorting="true"
                  />
                  <dx-column
                    data-field="status"
                    caption="Status"
                    data-type="boolean"
                    :allow-sorting="true"
                  />
                </DxDataGrid>
              </template>

              <template #tKeluarga>
                <DxDataGrid
                  id="dataGridKeluarga"
                  :data-source="keluargaResponse"
                  :focused-row-index="0"
                  :show-borders="true"
                  :show-column-lines="false"
                  :focused-row-enabled="true"
                  :column-auto-width="true"
                  :column-hiding-enabled="false"
                  :allow-column-reordering="true"
                  key-expr="id"
                >
                  <dx-paging :page-size="10" />
                  <dx-pager :show-page-size-selector="true" :show-info="true" />
                  <dx-filter-row :visible="true" />

                  <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"
                  />
                  <DxSelection mode="multiple" />
                  <DxColumnFixing :enabled="true" />
                  <DxToolbar>
                    <DxItem name="groupPanel" />
                    <DxItem location="after" template="button-template" />
                    <DxItem name="addRowButton" show-text="always" />
                    <DxItem name="exportButton" />
                    <DxItem name="columnChooserButton" />
                    <DxItem name="searchPanel" />
                  </DxToolbar>
                  <template #button-template>
                    <DxButton
                      text="Import data"
                      :width="136"
                      @click="importClick"
                    />
                  </template>
                  <dx-column data-field="nama" caption="Nama" />
                  <dx-column
                    data-field="keluarga_hub_id"
                    caption="Hubungan Keluarga"
                  >
                    <DxLookupDataGrid
                      :data-source="keluargaHubSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                  <DxColumn
                    data-field="tempat_lahir"
                    caption="Tempat Lahir"
                  ></DxColumn>
                  <DxColumn
                    data-field="tgl_lahir"
                    caption="Tgl Lahir"
                  ></DxColumn>
                  <DxColumn data-field="nik" caption="NIK"></DxColumn>
                  <dx-column
                    data-field="perkawinan_status_id"
                    caption="Status Pernikahan"
                  >
                    <DxLookupDataGrid
                      :data-source="perkawinanStatusSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>

                  <DxColumn
                    data-field="jenis_kelamin"
                    caption="Jenis Kelamin"
                  ></DxColumn>
                  <DxColumn data-field="" caption="Pekerjaan"></DxColumn>
                  <dx-column data-field="agama_id" caption="Agama">
                    <DxLookupDataGrid
                      :data-source="agamaSource"
                      value-expr="id"
                      display-expr="nama"
                    />
                  </dx-column>
                </DxDataGrid>
              </template>

              <template #tBasic>
                <DxForm :form-data="pegawaiResponse">
                  <DxGroupItem :col-count="2" css-class="first-group">
                    <DxGroupItem>
                      <DxSimpleItem data-field="nama">
                        <DxLabel text="Nama Pegawai" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="telp">
                        <DxLabel text="No. Telp" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="Email" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="tempat_lahir">
                        <DxLabel text="Tempat Lahir" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="tgl_lahir">
                        <DxLabel text="Tgl Lahir" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="Jenis Kelamin" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="Status Pernikahan" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="id">
                        <DxLabel text="Agama" />
                        <DxLookup
                          :dataSource="agamaSource"
                          valueExpr="id"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          @value-changed="onValueChangedLookup"
                          :value="selectedAgamaId"
                        >
                        </DxLookup>
                      </DxSimpleItem>
                    </DxGroupItem>
                    <DxGroupItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="ID Type" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="No. ID" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="Kode Pos" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="Alamat KTP" />
                      </DxSimpleItem>
                      <DxSimpleItem data-field="">
                        <DxLabel text="Alamat Domisili" />
                      </DxSimpleItem>
                      <DxButtonItem
                        :button-options="submitButtonOptions"
                        alignment="right"
                      />
                      <DxButtonItem
                        :button-options="submitButtonOptions"
                        alignment="right"
                      />
                      <DxButtonItem alignment="left">
                        <DxButtonOptions
                          text="Send an Email"
                          :on-click="buttonClick"
                        />
                      </DxButtonItem>
                    </DxGroupItem>
                  </DxGroupItem>
                </DxForm>
              </template>
            </DxTabPanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import router from "@/router";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxTreeView from "devextreme-vue/tree-view";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  // DxEditing,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxButton,
  DxToolbar,
  DxLookup as DxLookupDataGrid,
  DxItem,
} from "devextreme-vue/data-grid";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxButtonItem,
  DxButtonOptions,
} from "devextreme-vue/form";
import { DxLookup } from "devextreme-vue/lookup";
// import DataSource from "devextreme/data/data_source";

// import { DxTextArea } from "devextreme-vue/text-area";
import ODataStore from "devextreme/data/odata/store";
// import DataSource from "devextreme/data/data_source";
import { continents } from "./infoPegawai.js";

const submitButtonOptions = {
  text: "Submit the Form",
  useSubmitBehavior: false,
  onClick: function () {
    alert(this.tabPanelIndex);
  },
};

async function fetchData() {
  const response = await axios.get(
    "https://jsonplaceholder.typicode.com/posts"
  );
  return response.data;
}

async function fetchDataMaster(table) {
  const odataStore = new ODataStore({
    type: "odata",
    url: "http://127.0.0.1/odata/" + table,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ["id", "=", 1],
  });

  return data;
}

async function fetchDataPegawai() {
  const odataStore = new ODataStore({
    type: "odata",
    url: "http://127.0.0.1/odata/Pegawais?$filter=id eq " + getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ["id", "=", 1],
  });

  return data[0];
}

async function fetchDataPegawaiJob() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/JobHistories?$orderby=tgl_mulai desc&$expand=bagian,cabang,golongan,subBagian,jabatan&$filter=pegawai_id eq " +
      getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ['pegawai_id', '=', 1],
    // expand: ['bagian','cabang','golongan','sub_bagian','jabatan'],
    //menyebalkan
  });
  return data;
}

async function fetchDataPegawaiPendidikan() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/PendidikanHistories?$filter=pegawai_id eq " +
      getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ['pegawai_id', '=', 1],
    // expand: ['bagian','cabang','golongan','sub_bagian','jabatan'],
    //menyebalkan
  });
  return data;
}

async function fetchDataPegawaiKeluarga() {
  const odataStore = new ODataStore({
    type: "odata",
    url:
      "http://127.0.0.1/odata/Keluargas?$orderby=keluarga_hub_id asc&$filter=pegawai_id eq " +
      getPegawaiId(),
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  });
  const data = await odataStore.load({
    // filter: ['pegawai_id', '=', 1],
    // expand: ['bagian','cabang','golongan','sub_bagian','jabatan'],
    //menyebalkan
  });
  console.log("KELUARGA");
  console.log(data);
  return data;
}

function getPegawaiId() {
  // alert(router.currentRoute.value.query.id)
  return router.currentRoute.value.query.id;
}

let pegawaiSet = [];
export default {
  components: {
    DxTabPanel,
    DxTreeView,
    DxForm,
    DxLookup,
    DxLookupDataGrid,
    // DxTextArea,
    DxGroupItem,
    DxSimpleItem,
    DxLabel,
    DxDataGrid,
    DxColumn,
    DxButtonItem,
    DxButtonOptions,
    DxFilterRow,
    DxPager,
    DxPaging,
    // DxEditing,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxButton,
    DxToolbar,
    DxItem,
  },
  setup() {
    // alert(router.currentRoute.value.query.id)
    console.log("SETUP");

    console.log(router.currentRoute.value.query.id); //ngambil passed props
  },

  data() {
    // const positions = service.getPositions();

    return {
      selectedAgamaId: null,

      // imageSrc: "06.png",
      // positionEditorOptions: {
      //   items: positions,
      //   searchEnabled: true,
      //   value: "",
      // },
      cabangSource: new ODataStore({
        url: "http://127.0.0.1/odata/Cabangs",
        key: "id",
      }),
      jabatanSource: new ODataStore({
        url: "http://127.0.0.1/odata/Jabatans",
        key: "id",
      }),
      subBagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/SubBagians",
        key: "id",
      }),
      bagianSource: new ODataStore({
        url: "http://127.0.0.1/odata/Bagians",
        key: "id",
      }),
      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      keluargaHubSource: new ODataStore({
        url: "http://127.0.0.1/odata/KeluargaHubs",
        key: "id",
      }),
      perkawinanStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PerkawinanStatuses",
        key: "id",
      }),
      pendidikanJenjangSource: new ODataStore({
        url: "http://127.0.0.1/odata/PendidikanJenjangs",
        key: "id",
      }),
      continents,
      tabPanelIndex: 0,
      countryData: continents[0].items[0],
      citiesData: continents[0].items[0].cities,
      currentTemplate: "tBasic",
      submitButtonOptions,
      pegawaiSource: this.pegawaiDataSource,
      pegawaiData: pegawaiSet,
      responseData: null,
      pegawaiResponse: null,
      jobHistoryReponse: null,
      keluargaResponse: null,
      pendidikanHistorySource: null,
      pegawaiId: null,
      agamaSource: new ODataStore({
        url: "http://127.0.0.1/odata/Agamas",
        key: "id",
      }),
      // agamaSource: new DataSource({
      //   store: {
      //     type: "odata",
      //     url: "http://127.0.0.1/odata/Agamas",
      //     key: "id",
      //   },
      // }),
    };
  },
  beforeMount() {
    console.log("BEFOREMOUNT");
  },
  async mounted() {
    this.responseData = await fetchData();
    this.pegawaiResponse = await fetchDataPegawai();
    this.pendidikanHistorySource = await fetchDataPegawaiPendidikan();
    this.selectedAgamaId = this.pegawaiResponse.agama_id;
    this.jobHistoryReponse = await fetchDataPegawaiJob();
    this.keluargaResponse = await fetchDataPegawaiKeluarga();
    // this.agamaOptions = await fetchDataMaster("Agamas");
    console.log(await fetchDataMaster("Agamas"));
    this.pegawaiId = getPegawaiId();
  },

  methods: {
    onValueChangedLookup(e) {
      console.log(e.previousValue);
      console.log(e.value);
    },
    getPegawai() {
      console.log("GETPEGAWAI");
      console.log(this.pegawaiData);
      console.log(pegawaiSet);
    },
    tabTitleClick(e) {
      console.log("tabtitleclick");
      console.log(e.itemData.template);
      console.log(e.itemData);
      // e.itemData.disabled = false;
      console.log(e);
      console.log(DxTabPanel);
      console.log(this.tabPanelIndex);
      console.log(this.citiesData[this.tabPanelIndex]);
      // console.log(this.citiesData[this.tabPanelIndex]["disabled"]);
      // this.citiesData[this.tabPanelIndex]["disabled"] = true; //ngubah tab panel disable true false
    },
    changeSelection(e) {
      console.log("change selection");
      console.log(e.itemData);
      console.log(e);

      const countryData = e.itemData;
      if (countryData.cities) {
        this.countryData = e.itemData;
        this.citiesData = countryData.cities;
        this.tabPanelIndex = 0;
      }
    },
    buttonClick() {
      console.log("button clicked");
      let iNext = this.tabPanelIndex + 1;
      console.log(this.tabPanelIndex);
      console.log(iNext);
      console.log(this.citiesData[iNext]);
      // console.log(this.citiesData[this.tabPanelIndex]);
      // console.log(this.citiesData[this.tabPanelIndex]["disabled"]);
      // this.citiesData[iNext]["disabled"] = false; //ngubah tab panel disable true false
    },
  },
};
</script>

<style>
.container {
  position: relative;

  overflow-y: scroll; /*adds scrollbar */
}

.container,
.left-content {
  min-height: 900px;
}

.left-content {
  display: inline-block;
  width: 180px;
  padding: 0 10px 10px;
  background-color: rgba(191, 191, 191, 0.15);
  box-shadow: -5px 0 14px -8px rgba(0, 0, 0, 0.25) inset;
}

.right-content {
  position: absolute;
  right: 0;
  left: 220px;
  /*  makin kecil, makin kekiri */

  top: 0;
  height: 100%;
}

sup {
  font-size: 0.8em;
  vertical-align: super;
  line-height: 0;
}

.right-content .sub-title {
  font-size: 120%;
  /* color: rgba(152, 152, 152, 0.8); */
  color: black;
}

.title-container {
  min-height: 100px;
  margin-bottom: 10px;
}

.title-container .country-name {
  font-size: 240%;
  font-weight: bold;
  line-height: 34px;
  margin-bottom: 10px;
}

.title-container > div:not(.flag) {
  margin-left: 204px;
}

.stats {
  display: table;
  width: 100%;
  margin-bottom: 20px;
}

.stats > div {
  display: table-cell;
  text-align: center;
  border: 1px solid rgba(191, 191, 191, 0.25);
  padding: 20px 0 25px;
  width: 33%;
}

.stats > div:first-child,
.stats > div:last-child {
  border-right-width: 0;
  border-left-width: 0;
}

.stats .stat-value {
  font-size: 200%;
}

#tabpanel {
  margin-top: 10px;
}

#tabpanel .dx-multiview-wrapper {
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
}

#tabpanel .tab-panel-title {
  font-size: 100%;
  font-weight: 500;
}

#tabpanel .dx-multiview-item-content {
  padding: 20px 0 22px;
  min-height: 178px;
  position: relative;
}

#tabpanel .right-content {
  top: 15px;
  left: 202px;
}

#tabpanel .stats {
  width: 398px;
  margin-top: 20px;
  border-top: 1px solid rgba(191, 191, 191, 0.25);
}

#tabpanel .stats > div {
  padding: 7px 0;
  text-align: left;
  border: 0;
}

#tabpanel .stats > div:first-child {
  width: 40%;
}

#tabpanel .stats > div:not(:first-child) {
  width: 30%;
}

.flag {
  /* width: 172px;
  max-height: 122px;
  border: 1px solid rgba(191, 191, 191, 0.25);
  float: left;
  margin: 0 30px 10px 0;
  background-image: url("profile.png");
   */
  height: 122px;
  width: 128px;
  /* margin-right: 10px; */
  margin: 0 30px 10px 0;
  border: 1px solid #d2d3d5;
  float: left;
  border-radius: 50%;
  background-image: url("LOGO.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.left-content
  .dx-treeview-node.dx-state-selected
  > .dx-item
  > .dx-item-content {
  font-weight: 500;
}
</style>
